<template>
  <div>
    <hora>
      <div class="quickstart">
        <router-link :to="{name: 'hora_project_start', params: {projectIdentifier: project.identifier}, query: {year: year, month: month}}" tag="div"
                     @mouseover.native="quickstart_hover = project.identifier" @mouseout.native="quickstart_hover = null"
             v-for="project in recent_projects" class="project" :style="{
                backgroundColor: project.icc,
                borderColor: 'white',
                color: 'white',
             }">
          <div class="project-title">
            {{project.codename}}
          </div>
          <div class="play"><i class="material-icons">play_arrow</i></div>
        </router-link>
      </div>
      <div class="buttons">

        <div class="button-group">
          <button @click="show_all_projects = true" v-if="!show_all_projects && recent_projects.length !== $store.state.projects.length">
            <i class="material-icons">more_horiz</i>
          </button>
          <select v-model="track">
            <option v-for="track in available_tracks">{{track}}</option>
          </select>

        <router-link tag="button" :to="{name: 'hora_project_new'}">
          <i class="material-icons">add</i>
        </router-link>
        </div>


        <div class="button-group">
          <button @click="changeMonth(-1)"><i class="material-icons">arrow_left</i></button>
          <select v-model="year">
            <option v-for="year in years">{{ year }}</option>
         </select>
          <select v-model="month">
            <option v-for="index in 12">{{index}}</option>
          </select>
          <button @click="changeMonth(1)"><i class="material-icons">arrow_right</i></button>
        </div>
      </div>
      <entries :track="track" :project="quickstart_hover" :year="year" :month="month"></entries>
    </hora>
  </div>
</template>

<script>
import Hora from '@/layouts/Hora.vue'
import Entries from '@/components/Entries.vue'

export default {
  name: 'user_home',
  components: {Hora, Entries},
  data() {
    let now = new Date();
    return {
      show_all_projects: false,
      quickstart_hover: null,
      track: this.$store.state.track,
      year: this.$store.state.year || now.getFullYear(),
      month: this.$store.state.month || now.getMonth() + 1
    }
  },
  beforeCreate() {

  },
  watch: {
    year(val) {
      val = parseInt(val);
      this.year = val;
      this.$store.commit('setYear', val);
    },
    month(val) {
      val = parseInt(val);
      this.month = val;
      this.$store.commit('setMonth', val);
    },
    track(val) {
      this.$store.commit('SET_TRACK', val);
    }
  },
  computed: {
    recent_projects() {
      if (this.show_all_projects)
        return this.$store.state.projects.filter(project => {
          return project.track === this.track
        });
      let entries =  this.$store.state.entries.filter(entry => {
        return entry.start[0] === this.year && entry.start[1] === this.month;
      });
      return this.$store.state.projects.filter(project => {
        if (project.track !== this.track) return false;
        for (let i = 0; i < entries.length; ++i) {
          if (entries[i].project === project.identifier) return true;
        }
        return false;
      });
    },
    available_tracks() {
      let tracks = [];
      for (let i = 0; i < this.$store.state.projects.length; ++i) {
        let project = this.$store.state.projects[i];
        if (project.track && tracks.indexOf(project.track) < 0) {
          tracks.push(project.track);
        }
      }
      return tracks;
    },
    years() {
      let years = [];
      let workingYear = 2000;
      let currentYear = parseInt((new Date()).getFullYear());
      while (workingYear <= currentYear) {
        years.push(workingYear);
        workingYear++;
      }
      return years;
    }
  },
  methods: {
    changeMonth(val) {
      if (val > 0) {
        if (this.month + val <= 12) {
          this.month += val;
          return;
        }
        this.month = this.month + val - 12;
        this.year += 1;
      } else {
        if (this.month + val > 0) {
          this.month += val;
          return;
        }
        this.month = this.month + val + 12;
        this.year -= 1;
      }
    }
  }
}
</script>


<style lang="sass" scoped>
  div.quickstart
    display: flex
    justify-content: center
    flex-wrap: wrap
    margin: 1.5em 0

    @media print
      display: none

  div.project
    width: 7em
    font-size: 1.5em
    margin: 0.5em 0 0.5em 1.5em
    padding: 0.5em 0.5em 0.5em 1.5em
    text-align: center
    display: flex
    align-items: center
    justify-content: center
    position: relative
    color: white
    text-transform: uppercase
    font-weight: 600
    flex-grow: 1
    max-width: 16em
    border-radius: 4px
    cursor: pointer

    &.more
      background: #8b8b8b
      width: 3em
      max-width: 3em


  div.quickstart:hover
    div.project
      filter: grayscale(1)
      opacity: 0.5
      &:hover
        filter: none
        opacity: 1

  div.play
    position: absolute
    left: 0
    top: 50%
    width: 1.4em
    height: 1.4em
    margin-top: -0.7em
    margin-left: -0.7em
    border-radius: 100%
    display: flex
    justify-content: center
    align-items: center
    border-width: 0.16em
    border-style: solid
    background-color: inherit
    color: inherit
    border-color: inherit
    box-sizing: border-box

    i
      font-size: 1em
</style>
